module.exports = __webpack_public_path__ + "static/media/azaelmob.7c0074a7.jpg";